module.exports = __webpack_public_path__ + "img/american-credit-prequalify-promptly-640w.af5ded3.jpg";